module.exports = __webpack_public_path__ + "static/media/Montenegro - ME.84a05111.png";